function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import PaymentAccountId from '../PaymentAccountId';
import classNames from 'classnames';
import React, { useState } from 'react';
import { List } from 'immutable';
import style from './FromAndTo.module.css';
import textStyle from './text.module.css';
import MultiplePayeesTo from './MultiplePayeesTo';
export default function FromAndTo(_ref) {
  var debtor = _ref.debtor,
    creditor = _ref.creditor,
    creditorAgentIdentification = _ref.creditorAgentIdentification,
    creditorAgentScheme = _ref.creditorAgentScheme,
    showLabels = _ref.showLabels,
    _ref$paymentInstructi = _ref.paymentInstructions,
    paymentInstructions = _ref$paymentInstructi === void 0 ? List() : _ref$paymentInstructi,
    isBalanceTransfer = _ref.isBalanceTransfer;
  var debtorName = debtor ? debtor.getIn(['account', 'customerName']) : 'Not selected';
  var recipientName = creditor ? creditor.getIn(['account', 'customerName']) : "".concat(paymentInstructions.size, " Payees");
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPayeeListExpanded = _useState2[0],
    setPayeeListExpanded = _useState2[1];
  var onPayeeListToggle = function onPayeeListToggle() {
    return setPayeeListExpanded(!isPayeeListExpanded);
  };
  return /*#__PURE__*/React.createElement("section", {
    className: classNames(style.cardBody, 'js-from-and-to legacyCardBody', _defineProperty({}, style.withExpandedPayees, isPayeeListExpanded))
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(style.row, " ").concat(style.from, " js-from")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(style.heading, " js-section-heading")
  }, "From"), /*#__PURE__*/React.createElement("div", {
    className: style.accountDetails
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('js-name-text', style.accountName, textStyle.moduleTitle, getAccountTypeColor('FROM'))
  }, isBalanceTransfer ? recipientName : debtorName || 'Unknown account name'), isBalanceTransfer ? getPaymentAccountId('creditor') : getPaymentAccountId('debtor'))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(style.row, " js-to")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(style.heading, " js-section-heading")
  }, "To"), /*#__PURE__*/React.createElement("div", {
    className: style.accountDetails
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(style.accountName, textStyle.moduleTitle, 'js-name-text', getAccountTypeColor('TO'))
  }, isBalanceTransfer ? debtorName || 'Unknown account name' : recipientName), isBalanceTransfer ? getPaymentAccountId('debtor') : getPaymentAccountId('creditor'))), !paymentInstructions.isEmpty() && /*#__PURE__*/React.createElement(MultiplePayeesTo, {
    payees: paymentInstructions,
    onToggle: onPayeeListToggle,
    isExpanded: isPayeeListExpanded
  }));
  function getAccountTypeColor(type) {
    var debtorColor = debtor && debtorName ? 'ob-brand-colour' : 'zb-dark-grey-2';
    var styling = '';
    if (type === 'FROM') {
      styling = isBalanceTransfer ? 'ob-brand-colour' : debtorColor;
    } else {
      styling = isBalanceTransfer ? debtorColor : 'ob-brand-colour';
    }
    return styling;
  }
  function getPaymentAccountId(type) {
    return type === 'debtor' ? /*#__PURE__*/React.createElement(PaymentAccountId, {
      accountId: debtor,
      className: "zb-dark-grey-2"
    }) : creditor && /*#__PURE__*/React.createElement(PaymentAccountId, {
      accountId: creditor,
      agentIdentification: creditorAgentIdentification,
      agentScheme: creditorAgentScheme,
      showLabels: showLabels,
      className: classNames('zb-dark-grey-2', _defineProperty({}, style.withLabels, showLabels))
    });
  }
}